import React from "react";
import { useNavigate } from "react-router-dom";
import { FeatherArrowLeft } from "@subframe/core";
import { ReportsNav } from "../components/ReportsNav";
import { REPORTS_WORKBENCH_PATH } from "../config/reportsNavigation";

interface ReportsLayoutProps {
  children: React.ReactNode;
}

/**
 * Full-screen chrome for the reports area: report rail on the left, the
 * selected report on the right. Same shape as the settings area — the app
 * sidebar is absent, the rail carries the one way back.
 */
export const ReportsLayout: React.FC<ReportsLayoutProps> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen w-full items-start bg-default-background">
      <div className="flex w-64 shrink-0 flex-col gap-6 self-stretch overflow-y-auto border-r border-solid border-neutral-border px-4 py-6">
        <button
          type="button"
          onClick={() => navigate(REPORTS_WORKBENCH_PATH)}
          className="flex items-center gap-2 self-start rounded-md px-3 py-1.5 text-body font-body text-subtext-color transition-colors hover:bg-neutral-50 hover:text-default-font"
        >
          <FeatherArrowLeft className="text-body font-body" />
          Back to workbench
        </button>

        <div className="flex flex-col gap-4">
          <span className="px-3 text-heading-3 font-heading-3 text-default-font">Reports</span>
          <ReportsNav />
        </div>
      </div>

      <div className="flex h-full grow shrink-0 basis-0 flex-col items-start overflow-y-auto px-8">
        <div className="flex w-full grow shrink-0 basis-0 flex-col items-start py-8">{children}</div>
      </div>
    </div>
  );
};
